import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetOwner, successGetOwner } from './OwnerSlicer';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddOwner, successAddOwner } from './AddOwnerSlicer';
import { successUpdateowner, failureUpdateOwner } from './UpdateOwnerSlicer';
import { failureDeleteOwner, successDeleteOwner } from './DeleteOwnerSlice';
import { IOwnerList } from '../../../Pages/Owner/IOwner';

const OwnerApi = () => {
  return api.get('/parkingOwner/?skip=0&limit=1000');
};

export function* OwnerCall() {
  try {
    const response: AxiosResponse = yield call(OwnerApi);
    yield put(successGetOwner(response.data));
  } catch (error) {
    yield put(failureGetOwner(error));
  }
}

// add owner
const AddOwnerApi = (action: PayloadAction<IOwnerList>) => {
  const data = {
    first_name: action.payload.first_name,
    last_name: action.payload.first_name,
    email: action.payload.email,
    phone: action.payload.phone,
    status: action.payload.status,
  };
  return api.post('/parkingOwner/signUp', data);
};

export function* AddOwnerCall(action: PayloadAction<IOwnerList>) {
  try {
    const response: AxiosResponse = yield call(AddOwnerApi, action);
    yield put(successAddOwner(response.data));
  } catch (error:any) {
    yield put(failureAddOwner(error.response.data));
  }
}

// update owner
const UpdateOwnerApi = (action: PayloadAction<IOwnerList>) => {
  const formData = new FormData();

  Object.entries(action.payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const url = `/parkingOwner/${action.payload.id}`;

  return api.patch(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* UpdateOwnerCall(action: PayloadAction<IOwnerList>) {
  try {
    const response: AxiosResponse = yield call(UpdateOwnerApi, action);
    yield put(successUpdateowner(response.data));
  } catch (error) {
    yield put(failureUpdateOwner(error));
  }
}

// delete owner
const DeleteOwnerApi = (action: PayloadAction<number>) => {
  return api.delete(`/parkingOwner/${action.payload} `);
};
export function* DeleteOwnerCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteOwnerApi, action);
    yield put(successDeleteOwner(response.data));
  } catch (error) {
    yield put(failureDeleteOwner(error));
  }
}
